/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';
import * as Materials from '../../utils/materials';

/**
 * Should contain data that will be used for output or computing data for the next step in the wizard.
 */
export default class NextStepsResults extends EmberObject {
  filter = null;
  tolerances = null;
  specificationsInput = null;
  componentsInput = null;
  toleranceInput = null;
  opAmpSource = null;
  @computed('tolerances.magnitudeDb') get magnitudeDb() {
    return this.tolerances.magnitudeDb;
  }

  @computed('tolerances.magnitudeVV') get magnitudeVV() {
    return this.tolerances.magnitudeVV;
  }

  @computed('tolerances.phaseDegrees') get phaseDegrees() {
    return this.tolerances.phaseDegrees;
  }

  @computed('tolerances.phaseRadians') get phaseRadians() {
    return this.tolerances.phaseRadians;
  }

  @computed('tolerances.groupDelay') get groupDelay() {
    return this.tolerances.groupDelay;
  }

  @computed('tolerances.phaseDelay') get phaseDelay() {
    return this.tolerances.phaseDelay;
  }

  @computed('tolerances.stepResponse') get stepResponse() {
    return this.tolerances.stepResponse;
  }

  @computed('tolerances.inputImpedanceMagnitude') get inputImpedanceMagnitude() {
    return this.tolerances.inputImpedanceMagnitude;
  }

  @computed('tolerances.inputImpedancePhase') get inputImpedancePhase() {
    return this.tolerances.inputImpedancePhase;
  }

  @computed('tolerances.detailsOfCircuits') get detailsOfCircuits() {
    return this.tolerances.detailsOfCircuits;
  }

  @computed('tolerances.detailsOfStages') get detailsOfStages() {
    console.time('detailsOfStages');
    var result = this.tolerances.detailsOfStages;
    console.timeEnd('detailsOfStages');
    return result;
  }

  @computed('tolerances.needReferenceStage') get needReferenceStage() {
    return this.tolerances.needReferenceStage;
  }

  @computed('tolerances.noise') get noise() {
    return this.tolerances.noise;
  }

  @computed('tolerances.voltageRange') get voltageRange() {
    return this.tolerances.voltageRange;
  }

  @computed('tolerances.power') get power() {
    return this.tolerances.power;
  }

  @computed(
    'componentsInput.vsMinus',
    'filter.name',
    'needReferenceStage',
    'opAmpSource',
    'specificationsInput',
    'toleranceInput',
    'tolerances.{detailsOfCircuits,detailsOfStages}',
  )
  get billOfMaterials() {
    let filterType = this.filter.name;
    let specificationsInput = this.specificationsInput;
    let vsMinus = this.componentsInput.vsMinus;
    let needReferenceStage = this.needReferenceStage;
    let toleranceInput = this.toleranceInput;
    let stageDetails = this.tolerances.detailsOfStages;
    let circuitDetails = this.tolerances.detailsOfCircuits;
    let opAmpSource = this.opAmpSource;
    return Materials.billOfMaterials(
      filterType,
      specificationsInput,
      vsMinus,
      stageDetails,
      circuitDetails,
      toleranceInput,
      needReferenceStage,
      opAmpSource,
    );
  }

  @computed(
    'componentsInput.vsMinus',
    'needReferenceStage',
    'opAmpSource',
    'toleranceInput',
    'tolerances.{detailsOfCircuits,detailsOfStages}',
  )
  get evalBoardData() {
    let vsMinus = this.componentsInput.vsMinus;
    let needReferenceStage = this.needReferenceStage;
    let toleranceInput = this.toleranceInput;
    let stageDetails = this.tolerances.detailsOfStages;
    let circuitDetails = this.tolerances.detailsOfCircuits;
    let opAmpSource = this.opAmpSource;
    return Materials.orderEvalBoard(
      vsMinus,
      stageDetails,
      circuitDetails,
      toleranceInput,
      needReferenceStage,
      opAmpSource,
    );
  }

  @computed('opAmpSource', 'tolerances.detailsOfStages') get orderSamplesData() {
    let stageDetails = this.tolerances.detailsOfStages;
    let opAmpSource = this.opAmpSource;
    return Materials.orderSamples(stageDetails, opAmpSource);
  }
}
